var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallMountainGray(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 0l48 48L220 88.5H0l53-53L73.5 56l56-56z",
    fill: "#292929"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMountainGray);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='220' height='89' viewBox='0 0 220 89' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M129.5 0L177.5 48L220 88.5H0L53 35.5L73.5 56L129.5 0Z' fill='%23292929'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };